<script>
  export default {
    name: 'AboutUs',
    data () {
      return {
        members: [
          {
            name: 'Giulia Pettinau',
            role: 'CEO - Fondatrice e ideatrice di Orangogo.it',
            avatar: 'images/team/Giulia_Pettinau.jpg'
          },
          {
            name: 'Ambra Nagliati',
            role: 'Psicologa esperta in Psicologia dello Sport',
            avatar: 'images/team/Ambra_Nagliati.jpg'
          },
          {
            name: 'Giusy Cimino',
            role: 'Key Account',
            avatar: 'images/team/Giusy_Cimino.jpg'
          },
          {
            name: 'Marco Savasta',
            role: 'UX/UI Designer',
            avatar: 'images/team/Marco_Savasta.jpg'
          },
          {
            name: 'Nadia Giannuzzi',
            role: 'Communication Specialist',
            avatar: 'images/team/Nadia_Giannuzzi.jpg'
          },
          {
            name: 'Vito Scarangella',
            role: 'Full Stack Developer',
            avatar: 'images/team/VitoScarangella.jpg'
          },
          {
            name: 'Ottavio Riello Pera',
            role: 'Art Director',
            avatar: 'images/team/Ottavio_Riello_Pera.jpg'
          },
          {
            name: 'Josephine Siciliano',
            role: 'Data Scientist',
            avatar: 'images/team/Josephine_Siciliano.jpg'
          }
        ]
      }
    }
  }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/AboutUs.vue